<template>
    <div>
        <app-toolbarcustom app_title="Chat Bot" app_menu="home"></app-toolbarcustom>
      <v-container fluid>
        <!-- Chat Container -->
        <v-row justify="center" align="center" class="chat-container">
          <v-col cols="12" md="12">
            <v-card class="chat-card">
              <v-card-title class="headline">Chat with {{$vars.V('txt_group')}} AI</v-card-title>
              <v-divider></v-divider>
  
              <!-- Message Display Area -->
              <v-card-text class="chat-area" ref="chatArea">
                <v-list >
                  <v-list-item
                    v-for="(message, index) in messages"
                    :key="index"
                    :class="{'user-message': message.from === 'user', 'bot-message': message.from === 'bot'}"
                  >
                    <v-list-item-content>
                      <div v-html="$functions.ConvertToLinks(message.text)"></div>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
  
              <v-divider></v-divider>
  
              <!-- Input Area -->
              <v-card-actions>
                <v-text-field
                  v-model="form.userinput"
                  label="Ketik perintah anda"
                  @keyup.enter="sendMessage"
                  outlined
                  dense
                  autofocus
                  append-icon="mdi-send"
                  @click:append="sendMessage"
                />
                <!-- <v-btn @click="sendMessage" color="primary" icon class="mt-n6">
                  <v-icon>mdi-send</v-icon>
                </v-btn> -->
              </v-card-actions>
              <small class="mx-2">*<i>Data tidak akan disimpan di dalam database</i></small>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </template>
  
  <script>
  
  export default {
    data: () => ({
        form:{
            userinput: '',
            sessionid: ''
        },
        messages: [],
        snackbar: {
                dialog: false,
                timeout: 3000,
                text: '',
                color: 'error'
            },
    }),
    methods: {
      async sendMessage() {
        if (this.form.userinput.trim() === "") return;
  
        // Add user message to the chat
        this.messages.push({
          from: "user",
          text: this.form.userinput,
        });
        let userinput = this.form.userinput
        this.form.userinput = ''
        // Scroll to bottom of the chat area
        this.$nextTick(() => {
          const chatArea = this.$refs.chatArea;
          chatArea.scrollTop = chatArea.scrollHeight;
        });
  
        // Send message to the backend API
        try {
            let formdata = {
                sessionid: this.form.sessionid,
                message: userinput,
            }
            let param 	   = this.$functions.ParamPOST(formdata)
            await this.$axios.post(this.$functions.UrlPOST('apiChat'),param,{
            headers: {
                'Content-Type': 'text/plain; charset=ISO-8859-1'
            }
            })
            .then(response => {
                let feedback = response.data
                if (feedback.length > 0) {
                    // Clear user input
                    this.form.userinput = "";
                    this.form.sessionid = feedback[0].sessionid;
                    // Add bot response to the chat
                    this.messages.push({
                        from: "bot",
                        text: response.data[0].reply,
                    });
                    // Scroll to bottom after bot responds
                    this.$nextTick(() => {
                        const chatArea = this.$refs.chatArea;
                        chatArea.scrollTop = chatArea.scrollHeight;
                    })
                }
            })
            .catch(e => {
                this.SnackBar(true,'error',e,3000)
            })
        } catch (error) {
          console.error(error);
          this.messages.push({
            from: "bot",
            text: "Sorry, something went wrong. Please try again.",
          });
        }
      },
      SnackBar(dialog, color, text, timeout) {
            this.snackbar = {
                dialog: dialog,
                color: color,
                text: text,
                timeout: timeout,
            }
        },
    },
  };
  </script>
  
  <style scoped>
  .chat-container {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .chat-card {
    width: 100%;
    max-width: 100%;
    height: 80vh;
    display: flex;
    flex-direction: column;
  }
  
  .chat-area {
    height: calc(100% - 130px); /* Adjust height for title, actions, and input area */
    overflow-y: auto;
    padding: 10px;
  }
  
  .user-message {
    background-color: #e3f2fd;
    border-radius: 8px;
    padding: 10px;
    margin-bottom: 10px;
    text-align: right;
  }
  
  .bot-message {
    background-color: #f1f1f1;
    border-radius: 8px;
    padding: 10px;
    margin-bottom: 10px;
  }
  
  .v-card-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
  .v-text-field {
    flex-grow: 1;
  }
  </style>
  